import { BIRTH_DATE_VALIDATOR } from './base-client';
import { buildValidations, validator } from 'ember-cp-validations';
import { or, reads } from '@ember/object/computed';
import AddressableMixin from 'client-portal/mixins/polymorphic/addressable';
import PhoneableMixin from 'client-portal/mixins/polymorphic/phoneable';
import Super from './treatable-client';
import classic from 'ember-classic-decorator';

const Validations = buildValidations({
  firstName: validator('presence', {
    presence: true,
    ignoreBlank: true,
    descriptionKey: 'errors.client.firstName',
    messageKey: 'errors.firstNameRequired',
  }),
  lastName: validator('presence', {
    presence: true,
    ignoreBlank: true,
    descriptionKey: 'errors.client.lastName',
    messageKey: 'errors.lastNameRequired',
  }),
  email: [
    validator('presence', {
      presence: true,
      disabled: reads('model.hasOneClientRelationship'),
      ignoreBlank: true,
      descriptionKey: 'errors.client.email',
      messageKey: 'errors.presence',
    }),
    validator('format', {
      type: 'email',
      allowBlank: true,
      descriptionKey: 'errors.client.email',
      messageKey: 'errors.format',
    }),
  ],
  phoneNumber: [
    validator('presence', {
      presence: true,
      disabled: or('model.hasOneClientRelationship', 'model.claimValidationsEnabled'),
      descriptionKey: 'errors.client.phoneNumber',
      messageKey: 'errors.presence',
    }),
    validator('length', {
      allowBlank: true,
      is: 10,
      disabled: reads('model.claimValidationsEnabled'),
      descriptionKey: 'errors.client.phoneNumber',
      messageKey: 'errors.client.phoneNumberLength',
    }),
  ],
  clientRelationships: validator('has-many', {
    descriptionKey: 'errors.client.clientRelationships',
    messageKey: 'errors.presence',
  }),
  birthDate: BIRTH_DATE_VALIDATOR,
  state: validator('presence', {
    presence: true,
    disabled: or('model.skipContactFormSpecificValidations', 'model.skipPrescreenerValidation'),
    descriptionKey: 'errors.client.state',
    messageKey: 'errors.presence',
  }),
});

@classic
export default class Client extends Super.extend(Validations, PhoneableMixin, AddressableMixin) {
  skipContactFormSpecificValidations = true;

  static fieldsFor(context) {
    let fields = this.superclass.fieldsFor(context);

    switch (context) {
      case 'environment':
        fields.addObjects(['channelCoveredSessionsCount', 'channelCoveredSessionsCountRemaining']);
        break;
    }

    return fields;
  }
}
